import { ClusterModelSet } from "in_queue/types/clusterType";
import { ScenarioMetadata } from "in_queue/types/scenarioType";
import { DateTime } from "luxon";

type StaleScenarioTiming = Pick<ScenarioMetadata, "type" | "timeMetadata">;

const formatDate = (date: Date): string =>
    DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_MED);

// Mirrors the Hasura `scenario_is_stale` function, which compares a shared
// scenario's creation time and any other scenario's run start time against the
// newest base scenario. Change both together.
const staleReferenceTime = (scenario: StaleScenarioTiming): Date | undefined =>
    scenario.type === "SHARED"
        ? scenario.timeMetadata.createdAt
        : scenario.timeMetadata.runStartedAt ??
          scenario.timeMetadata.runCompletedAt;

/**
 * Explain why a stale scenario is stale. Quote the model set's date only when
 * new model files landed after the run. Otherwise the newer base came from
 * updated study inputs on the same models, such as a queue update.
 */
export const describeStaleScenario = (
    scenario: StaleScenarioTiming,
    currentModelSet: Pick<ClusterModelSet, "createdAt"> | null
): string => {
    const ranAt = scenario.timeMetadata.runCompletedAt;
    const referenceTime = staleReferenceTime(scenario);
    const ranSentence =
        ranAt !== undefined
            ? `This scenario ran on ${formatDate(ranAt)}. `
            : "";
    return (
        ranSentence +
        (currentModelSet !== null &&
        referenceTime !== undefined &&
        currentModelSet.createdAt > referenceTime
            ? `The cluster's current model files landed on ${formatDate(
                  currentModelSet.createdAt
              )}.`
            : `Nira has updated the cluster's study inputs since ${
                  ranAt !== undefined ? "then" : "it ran"
              }.`)
    );
};
